import { render, staticRenderFns } from "./UserAvatarUpload.vue?vue&type=template&id=2988bc34"
import script from "./UserAvatarUpload.vue?vue&type=script&lang=js"
export * from "./UserAvatarUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports